import React from "react";
import { Box, Typography } from "@mui/material";
import { M, TYPE_LABELS } from "./marketplaceTokens";

const TYPES = [undefined, "TEST", "SKILL_SHEET", "DOCUMENT", "CLASS_TEMPLATE"];

function Facet({ title, options, value, onChange }) {
  return (
    <Box component="fieldset" sx={{ border: 0, m: 0, p: 0, display: "flex", flexDirection: "column", gap: "2px" }}>
      <Typography component="legend" sx={{ fontSize: "10px", fontWeight: 700, letterSpacing: ".025em", textTransform: "uppercase", color: M.ink3, mb: "8px", p: 0 }}>{title}</Typography>
      {options.map(({ value: v, label }) => (
        <Box key={label} component="label" sx={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "14px", p: "6px 8px", borderRadius: "6px", cursor: "pointer", "&:hover": { bgcolor: M.surface2 } }}>
          <Box component="input" type="radio" checked={value === v} onChange={() => onChange(v)} sx={{ width: 16, height: 16, m: 0, accentColor: M.primary }} />
          <span>{label}</span>
        </Box>
      ))}
    </Box>
  );
}

/** Type + Category only — server search takes a single `category` value, and listings never carry the
 * publishing tenant's identity (MarketplaceService strips sourceTenantId), so there's no "Shared by" facet. */
export default function MarketplaceFacets({ type, setType, category, setCategory, categories }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "22px" }}>
      <Facet title="Type" value={type} onChange={setType} options={TYPES.map((t) => ({ value: t, label: t ? TYPE_LABELS[t] : "All" }))} />
      <Facet title="Category" value={category} onChange={setCategory}
        options={[{ value: "", label: "All categories" }, ...categories.map((c) => ({ value: c, label: c }))]} />
    </Box>
  );
}
